var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 3.44446H2.22222H12",
    stroke: "#F1819E",
    strokeWidth: 1.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7777 3.44444V12C10.7777 12.3242 10.649 12.635 10.4197 12.8642C10.1905 13.0935 9.87965 13.2222 9.5555 13.2222H3.44439C3.12024 13.2222 2.80936 13.0935 2.58015 12.8642C2.35094 12.635 2.22217 12.3242 2.22217 12V3.44444M4.0555 3.44444V2.22222C4.0555 1.89807 4.18427 1.58719 4.41348 1.35798C4.64269 1.12877 4.95357 1 5.27772 1H7.72217C8.04632 1 8.3572 1.12877 8.58641 1.35798C8.81562 1.58719 8.94439 1.89807 8.94439 2.22222V3.44444",
    stroke: "#F1819E",
    strokeWidth: 1.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.27783 6.5V10.1667",
    stroke: "#F1819E",
    strokeWidth: 1.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.72217 6.5V10.1667",
    stroke: "#F1819E",
    strokeWidth: 1.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.ec1e2bf32221a3783a43429cfdb966bb.svg";
export { ForwardRef as ReactComponent };